import { useHotkeys } from '@/hooks/useHotkeys';
import { usePermissions } from '@/hooks/usePermissions';
import { CashPayoutModal } from './CashPayoutModal';
import { isCashPayoutOpen, openCashPayout } from './payoutStore';

/**
 * Mounts the global "Cash paid out" dialog and registers Alt+E (cashier / admin / super_admin).
 * Alt+E is ignored while another dialog (e.g. the closing-cash prompt) is open, like the original app.
 */
export function CashPayoutHost() {
  const { isAdmin, isCashier } = usePermissions();
  const allowed = isAdmin || isCashier;

  useHotkeys(
    [
      {
        keys: 'alt+e',
        description: 'Cash paid out',
        group: 'Shifts',
        allowInInputs: true,
        handler: () => {
          if (isCashPayoutOpen()) return;
          if (document.querySelector('[role="dialog"][aria-modal="true"]')) return;
          openCashPayout();
        },
      },
    ],
    { enabled: allowed },
  );

  return allowed ? <CashPayoutModal /> : null;
}
